import ReactPlayer from "react-player";
import { getAsset } from "@/helpers/helper";
import dummyUser from "@/assets/images/dummy/user-avatar-img.jpg";

const PostCard = ({ post, infooo }) => {
    const sharedFrom = post?._sharedFrom;
    const authorName =
        (typeof sharedFrom === "object" &&
          (sharedFrom?.fullname || sharedFrom?.fullname)) ||
        (typeof sharedFrom === "string" ? sharedFrom : null) ||
        infooo?.fullname ||
        "User";
    const authorImageRaw =
        (typeof sharedFrom === "object" &&
          (sharedFrom?.imageUrl || sharedFrom?.image)) ||
        infooo?.imageUrl;
    const authorImage = Array.isArray(authorImageRaw)
        ? authorImageRaw.find(Boolean)
        : authorImageRaw;
    const avatarSrc = authorImage ? getAsset(authorImage) : dummyUser;

    return (
        <div
            className="mt-3 bg-white rounded p-3"
            style={{ boxShadow: "0px 0px 5px 1px rgba(0,0,0,0.2)", margin: "1px" }}
        >
            {/* Author */}
            <div className="d-flex mb-2">
                <img
                    src={avatarSrc}
                    alt={authorName}
                    className="personImgSize"
                    crossOrigin="anonymous"
                    onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = dummyUser; }}
                />
                <div>
                    <h4 className="font-sm mb-0 mt-2 ms-2">{authorName}</h4>
                    <p className="font_small ms-2">
                        {post?._isShared
                            ? `Shared · ${post?.businessType || "generalPublic"}`
                            : post?.businessType}
                    </p>
                </div>
            </div>

            {/* Content */}
            {post?.heading && (
                <h5 className="font-navy font-bold">{post.heading}</h5>
            )}
            {post?.content && (
                <p className="font_small">{post.content}</p>
            )}

            {/* Images */}
            {post?.img?.map(
                (src, i) =>
                    src && (
                        <img
                            key={`img-${i}`}
                            src={getAsset(src)}
                            alt={`post-img-${i}`}
                            className="w-100 mb-2"
                            crossOrigin="anonymous"
                        />
                    )
            )}

            {/* Videos */}
            {post?.video?.map(
                (src, i) =>
                    src && (
                        <ReactPlayer
                            key={`video-${i}`}
                            url={getAsset(src)}
                            controls
                            width="100%"
                        />
                    )
            )}
        </div>
    );
};

export default PostCard;